<template>
  <div>
  <input type="search" v-model="ArananKelime" autofocus class="form-control p-3 mb-4" placeholder="Aramak için yazınız">


<ul  v-for="(fiil, index) in filteredList" v-bind:key="index" class="list-group  mb-3">
     <li class="list-group-item bg-light text-dark d-flex justify-content-between align-items-center"> {{ fiil.Turkcesi }}
           <span v-if="fiil.Duzensizmi" class="badge bg-success">Düzenli </span>    
           <span v-else class="badge bg-primary">Düzensiz</span>  
     </li>
     <li v-on:click="Copy(fiil.BirinciHali)" class="list-group-item list-group-item-action"> <span class="badge bg-secondary">1</span> {{ fiil.BirinciHali }}</li>
     <li v-on:click="Copy(fiil.IkinciHali)"  class="list-group-item list-group-item-action"><span class="badge bg-secondary">2</span> {{ fiil.IkinciHali }}</li>
     <li v-on:click="Copy(fiil.UcuncuHali)"  class="list-group-item list-group-item-action"><span class="badge bg-secondary">3</span> {{ fiil.UcuncuHali }}</li>
     <li class="list-group-item">{{ fiil.Not }}</li>

</ul>
<!-- <table>
    <thead>
        <tr>
            <th v-for="item in Fields" :key="item"> {{ item }} </th>
        </tr>
    </thead>
    <tbody>
        
       <tr v-for="(fiil, index) in Fiiller" v-bind:key="index" > 
           <td  v-for="item in Fields" :key="item" >{{ index }} {{ fiil[item] }} </td>
       </tr>
     
    </tbody>
</table> -->

  </div>
</template>

<script>
var Airtable = require('airtable');
var base = new Airtable({apiKey: 'key8KJohKo3YfzApM'}).base('appt3sDjwsMS76IuF');
const table = base('fiiller')

export default {
    data(){
        return{
            Fiiller:[],
            ArananKelime:'',
            Fields:''
            
        }
    },
    computed:{
            filteredList(){
                if(this.ArananKelime.length > 1){
                    return this.Fiiller.filter(post=>{
                    let kelime = this.ArananKelime.toLowerCase()
                    let sonuc = post.Turkcesi.toLowerCase().includes(kelime) || 
                                post.BirinciHali.toLowerCase().includes(kelime) ||
                                post.IkinciHali.toLowerCase().includes(kelime)||
                                post.UcuncuHali.toLowerCase().includes(kelime)
                    return  sonuc
                })
                } else{
                     return false
                }
            }
    },
    methods: {
              async Copy(mesaj){
                   await navigator.clipboard.writeText(mesaj)
                }
       
        
    },
    created()
    {
        var self = this  
            // table.select({view: 'fiil_table'}).firstPage(function(err, records) {
            // records.forEach(record =>{
            // self.Fiiller.push(record.fields)
            // })
            //  self.Fields = Object.keys(self.Fiiller[0])
        
            //   });

                table.select({
                    view: "fiil_table"
                }).eachPage(function page(records, fetchNextPage) {


                    records.forEach(function(record) {
                         self.Fiiller.push(record.fields)
                    });

                    fetchNextPage();
                    self.Fields = Object.keys(self.Fiiller[0])
                    
                }, function done(err) {
                    if (err) { console.error(err); return; }
                });
   
    },
}
</script>

<style>

</style>